import axios from '../base/axios';
import API_KEY from './key';

const GET_FLIXFRENZYORIGINALS = 'flixfrenzy/redux/GET_FLIXFRENZYORIGINALS';

// eslint-disable-next-line default-param-last
const flixFrenzyOriginalsReducer = (state = [], action) => {
  switch (action.type) {
    case GET_FLIXFRENZYORIGINALS:
      return action.payload;
    default:
      return state;
  }
};

export const getFlixFrenzyOriginals = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_network=213`).then((res) => {
    dispatch({
      type: GET_FLIXFRENZYORIGINALS,
      payload: res.data,
    });
  });
};

export default flixFrenzyOriginalsReducer;
